import { type QueryRef } from '@apollo/client'
import { useEffect, useMemo } from 'react'
import { Outlet } from 'react-router'
import {
  useCompanyPath,
  useIdCompany,
  useRBAC,
  useReadQuery,
} from '@/lib/hooks'
import type { WebhookQuery } from '@/routes/webhook/queries.types.gen'

type Props = {
  queryRef: QueryRef<WebhookQuery>
}

export const RBACCheck = ({ queryRef }: Props) => {
  const { idCompany } = useIdCompany()
  const { navigateToPath } = useCompanyPath()
  const { rbac } = useRBAC()
  const { data } = useReadQuery(queryRef)

  const idWebhook = useMemo(() => data?.company?.webhook?.id ?? '', [data])
  const idCompanyWebhook = useMemo(
    () => data?.company?.webhook?.idCompany ?? '',
    [data]
  )

  useEffect(() => {
    if (
      (idCompanyWebhook && idCompany && idCompanyWebhook !== idCompany) ||
      !idCompanyWebhook
    ) {
      navigateToPath({
        pathname: '/webhooks',
        idCompany,
      })
    }
    rbac.company(idCompany).apps.create.ensure()
    rbac.company(idCompany).databases.create.ensure()
    rbac.company(idCompany).staticSites.create.ensure()
    rbac.company(idCompany).objectStorages.create.ensure()
  }, [idWebhook, rbac, idCompany, idCompanyWebhook, navigateToPath])

  return <Outlet />
}
